export interface ServiceCategoryOption {
  id: string
  name: string
}

const PROJECT_TYPE_VALUES = ['maintenance', 'cleaning', 'landscaping', 'security', 'custom'] as const

/** Map a lead project work_type (category id or legacy slug) to proposal request project_type. */
export function mapWorkTypeToProjectType(
  workType: string | null | undefined,
  serviceCategories: ServiceCategoryOption[] = []
): string {
  if (!workType) return ''

  const normalized = workType.trim().toLowerCase()
  if (PROJECT_TYPE_VALUES.includes(normalized as typeof PROJECT_TYPE_VALUES[number])) {
    return normalized
  }

  const category = serviceCategories.find((c) => c.id === workType)
  if (!category) return ''

  const nameLower = category.name.toLowerCase()
  if (nameLower.includes('maintenance')) return 'maintenance'
  if (
    nameLower.includes('cleaning') ||
    nameLower.includes('janitorial') ||
    nameLower.includes('hallway')
  ) {
    return 'cleaning'
  }
  if (nameLower.includes('landscap')) return 'landscaping'
  if (nameLower.includes('security')) return 'security'
  return 'custom'
}

/** Resolve a proposal project_type slug to a service category id for lead project work_type. */
export function mapProjectTypeToWorkTypeId(
  projectType: string,
  serviceCategories: ServiceCategoryOption[] = []
): string {
  if (!projectType) return ''

  const directCategory = serviceCategories.find((c) => c.id === projectType)
  if (directCategory) return directCategory.id

  const normalized = projectType.trim().toLowerCase()
  const keywordCategory = serviceCategories.find((c) => {
    const nameLower = c.name.toLowerCase()
    if (normalized === 'cleaning') {
      return (
        nameLower.includes('cleaning') ||
        nameLower.includes('janitorial') ||
        nameLower.includes('hallway')
      )
    }
    if (normalized === 'landscaping') return nameLower.includes('landscap')
    return nameLower.includes(normalized)
  })

  return keywordCategory?.id || projectType
}

/** Display label for project_type / work_type (category id or legacy slug). */
export function formatWorkTypeDisplay(
  projectType: string | null | undefined,
  serviceCategories: ServiceCategoryOption[] = []
): string {
  if (!projectType) return ''

  const category = serviceCategories.find((c) => c.id === projectType)
  if (category) return category.name

  return projectType
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
